export const initialData = {
    day: '',
    month: '',
    year: '',
    fullDate: ''
};

export const SET_DAY = 'SET_DAY';
export const SET_MONTH = 'SET_MONTH';
export const SET_YEAR = 'SET_YEAR';
export const SET_FULL_DATE = 'SET_FULL_DATE';

const setFullDate = ({ day, month, year }) => `${day}${month ? `-${month}` : ''}${year ? `-${year}` : ''}`;

export const reducer = (state, action) => {
    const { type, payload } = action;

    switch (type) {
        case SET_DAY: {
            return {
                ...state,
                day: payload,
                fullDate: setFullDate({ day: payload, month: state.month, year: state.year })
            };
        }

        case SET_MONTH: {
            return {
                ...state,
                month: payload,
                fullDate: setFullDate({ day: state.day, month: payload, year: state.year })
            };
        }

        case SET_YEAR: {
            return {
                ...state,
                year: payload,
                fullDate: setFullDate({ day: state.day, month: state.month, year: payload })
            };
        }

        case SET_FULL_DATE: {
            const [day = '', month = '', year = ''] = payload?.split('-') || [];

            return {
                day,
                month,
                year,
                fullDate: payload
            };
        }

        default:
            throw new Error(`Unknown action type ${type}`);
    }
};
